import ES from "./ES";
import EU from "./EU";
import FR from "./FR";
import IL from "./IL";
import NL from "./NL";
import RU from "./RU";
import USA from "./USA";

const CountryFlags = {
  ES,
  EU,
  FR,
  IL,
  NL,
  RU,
  USA,
};

export default CountryFlags;
